/**
 * TODO: Need to refactor.
 * This file is copied from `src/pages/courses/useCurrentCourse.js`.
 */
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { find } from 'lodash';

import { addProductToCartCall, buyTheFreeCourseCall } from '@src/store/actions/purchase';
import { getFileVideoUrlCall } from '@src/store/actions/upload';
import { getIsSignIn, getIsPreview } from '@src/store/selectors/session';
import { getCurrentCourse, getCurrentCourseState, getCurrentCourseGeneralState } from '@src/store/selectors/course';
import { getFileVideoObject } from '@src/store/selectors/upload';
import { getShoppingCartProducts } from '@src/store/selectors/cart';
import { getBuyTheFreeCourseState, getAddingProductState } from '@src/store/selectors/purchase';
import { TSideEffectState } from '@src/types/common';
import { ICourse } from '@src/types/course';

import { getNextHomeworkLink } from '@src/utils/course';

interface ICurrentCourse {
	currentCourse: ICourse;
	currentCourseState: TSideEffectState;
	currentCourseGeneralState: TSideEffectState;
	isProductInCart: boolean;
	canSubmitRating: boolean;
	addingProductState: string;
	buyTheFreeCourseState: string;
	isPreview: boolean;
	handleAddToCart: () => void;
	handleGoToCart: () => void;
	handleBuyFreeCourse: () => void;
	handleStartCourse: () => void;
	handleSubmitHomework: () => void;
	handleGetCertificate: () => void;
}

const useCurrentCourse = (): ICurrentCourse => {
	const dispatch = useDispatch();
	const router = useRouter();
	const currentCourse = useSelector(getCurrentCourse) as ICourse;
	const currentCourseState = useSelector(getCurrentCourseState);
	const currentCourseGeneralState = useSelector(getCurrentCourseGeneralState);
	const cartProducts = useSelector(getShoppingCartProducts);
	const isPreview = useSelector(getIsPreview) as boolean;
	const product_id = currentCourse?.product_id;
	const short_link = currentCourse?.short_link;
	const course_id = currentCourse?.id;
	const isRevoked = currentCourse?.access_right_status === 'revoked';
	const isExpired = currentCourse?.access_right_status === 'expired';

	const isSignedIn = useSelector(getIsSignIn);
	const isProductInCart = !!find(cartProducts.products, course => course.course_id === course_id);
	const buyTheFreeCourseState = useSelector(getBuyTheFreeCourseState(product_id)) as string;
	const addingProductState = useSelector(getAddingProductState(product_id)) as string;

	const canSubmitRating =
    isSignedIn &&
    currentCourse?.bought === true &&
    currentCourse?.paid === true &&
    currentCourse?.has_been_rated === false;

	const handleAddToCart = () => {
		dispatch(addProductToCartCall({ product_id, short_link, course: currentCourse }));
	};

	const handleGoToCart = () => {
		router.push('/cart');
	};

	const handleBuyFreeCourse = () => {
		const courseId = currentCourse.id;

		dispatch(buyTheFreeCourseCall({ product_id, courseId, short_link }));
	};

	const handleStartCourse = () => {
		router.push(`/my_courses/${currentCourse?.short_link}`);
	};

	const handleSubmitHomework = () => {
		const homeworkUrl = getNextHomeworkLink(currentCourse);
		router.push(homeworkUrl);
	};

	const handleGetCertificate = () => {
		router.push(`/my_courses/${currentCourse?.short_link}/certificate`);
	};

	const getUnitVideo = useSelector(getFileVideoObject);
	const videoUrl = getUnitVideo?.url || currentCourse?.video_link?.link;
	useEffect(() => {
		if (currentCourse?.video_link?.id && getUnitVideo?.id !== currentCourse?.video_link?.id) {
			dispatch(
				getFileVideoUrlCall({
					id: currentCourse?.video_link?.id,
				}),
			);
		}
	}, [currentCourse?.video_link?.id]);

	return {
		currentCourse: {
			...currentCourse,
			paid: isRevoked || isExpired ? false : currentCourse?.paid,
			bought: isRevoked || isExpired ? false : currentCourse?.bought,
			video_link: {
				...currentCourse?.video_link || {},
				link: videoUrl,
			},
		},
		currentCourseState,
		currentCourseGeneralState,
		isProductInCart,
		canSubmitRating,
		addingProductState,
		buyTheFreeCourseState,
		isPreview,
		handleAddToCart,
		handleGoToCart,
		handleBuyFreeCourse,
		handleStartCourse,
		handleSubmitHomework,
		handleGetCertificate,
	};
};

export default useCurrentCourse;
